import React, { useState, useEffect } from 'react';
import classes from './style/CreatingTheme.module.css';
import { Button, Form, Input, Select, Space, Popconfirm } from 'antd';
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ApiCenter } from '../../api/ApiCenter';
import { useNavigate } from 'react-router-dom';
import { FileTextOutlined } from '@ant-design/icons';
import { UI_Footer } from '../../../Core/Core';

interface Theme {
  title: string;
  description: string;
  video: string;
  lesson_order: string;
}
interface IonFinishTheme {
  title: string;
  category_id: string;
  Theme: Theme[];
}
interface ItransformedData {
  theme: {
    title: string;
    category_id: string;
    is_draft: boolean;
  };
  lessons: {
    title: string;
    description: string;
    video?: string;
    lesson_order: string;
  }[];
}
const CreatingTheme = () => {
  const ApiStart = new ApiCenter();
  const { Option } = Select;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [draft, setDraft] = useState(false);
  const [nav, setNav] = useState<string>('/education');
  const onFinish = (values: IonFinishTheme) => {
    const transformedData: ItransformedData = {
      theme: {
        title: values.title,
        category_id: values.category_id,
        is_draft: draft,
      },
      lessons: values.Theme.map((theme) => {
        const lesson = {
          title: theme.title,
          description: theme.description,
          video: theme.video,
          lesson_order: theme.lesson_order,
        };
        return lesson;
      }),
    };

    ApiStart.GET_API('hr/theme', 'POST', transformedData).then((res) => {
      if (res.success) {
        navigate(nav);
      } else {
        alert(res.message);
      }
    });
  };

  const createTest = () => {
    setNav('../../tests/creating-test');
  };
  const draftSave = (param: boolean): void => {
    setDraft(param);
    form.submit();
  };
  const confirmOffPage = () => {
    navigate('/education');
  };
  useEffect(() => {
    setDraft(false);
    form.submit();
  }, [nav]);
  return (
    <>
      <div className={classes.Wrapper}>
        <div className={classes.HeaderNav}>
          <div className={classes.HeaderTitle}>
            <h1>Создание темы</h1>
          </div>
          <div className={classes.HeaderButtonBack}>
            <Popconfirm
              placement="right"
              title={'Закрыть создание теста'}
              onConfirm={confirmOffPage}
              okText="Да Закрыть"
              cancelText="Продолжить создание теста"
            >
              <CloseOutlined />
            </Popconfirm>
          </div>
        </div>
        <Form
          form={form}
          name="CreatingTheme"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item label="Название темы" name="title">
            <Input />
          </Form.Item>
          <div className={classes.themeName}>
            <Form.Item style={{ width: 450 }} label="Категория урока" name="category_id">
              <Select placeholder="Категория урока">
                <Option value={2}>Продажи</Option>
                <Option value={3}>Кредитование</Option>
                <Option value={4}>HR</Option>
                <Option value={5}>IT</Option>
              </Select>
            </Form.Item>
            <div style={{ color: '#888' }}>
              Выберите категорию для дальнейшей сортировки тем на странице.
            </div>
          </div>
          <Form.List name="Theme">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index: number) => {
                  const confirmDeleteLesson = () => {
                    remove(name);
                  };
                  return (
                    <Space key={key} style={{ display: 'block', marginBottom: 8 }} align="baseline">
                      <div className={classes.WrapperLissensIndex}>
                        <div> Урок {index + 1}</div>
                        <div>
                          <Popconfirm
                            placement="right"
                            title={'Удалить урок ?'}
                            onConfirm={confirmDeleteLesson}
                            okText="Да удалить урок"
                            cancelText="Отмена"
                          >
                            <Button>
                              Удалить урок <DeleteOutlined />
                            </Button>
                          </Popconfirm>
                        </div>
                      </div>

                      <Form.Item
                        {...restField}
                        name={[name, 'title']}
                        rules={[{ required: true, message: 'Введите название урока' }]}
                        label="Название урока"
                      >
                        <Input placeholder="Введите название урока" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'description']}
                        rules={[{ required: false, message: 'Missing first name' }]}
                        label="Описание урока"
                        style={{ height: 370 }}
                      >
                        <ReactQuill style={{ height: 300 }} />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'video']}
                        rules={[{ required: false, message: 'Missing last name' }]}
                        label="Ссылка на видео"
                      >
                        <Input placeholder="Ссылка на видео" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'lesson_order']}
                        initialValue={index + 1}
                      >
                        <Input type="hidden" />
                      </Form.Item>
                      {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                    </Space>
                  );
                })}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block>
                    + Добавить урок
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <p>Тест по теме:</p>
          {
            <div className={classes.testTheme}>
              <FileTextOutlined />
              <div>Тест еще не назначен. Создайте тест и назначьте его в меню создания теста.</div>
            </div>
          }
          <UI_Footer>
            <div>
              <Button onClick={() => draftSave(true)}>Сохранить в черновик</Button>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <Button type="primary" onClick={createTest}>
                Сохранить тему и создать тест
              </Button>
              <Button type="primary" onClick={() => draftSave(false)}>
                Сохранить тему
              </Button>
            </div>
          </UI_Footer>
        </Form>
      </div>
    </>
  );
};
export default CreatingTheme;
